import React from 'react';
import { Typography } from '@material-ui/core';
import { Content, Header } from '@backstage/core-components';
import { AuditLogsGrid } from '../components/AuditLogsGrid/AuditLogsGrid';

export default function AuditLogsPage() {
  return (
    <>
      <Header
        pageTitleOverride="Audit logs"
        title={<Typography variant="h4">Audit logs</Typography>}
        subtitle="DIAM activity for the current team and its sub-teams"
      />
      <Content>
        <AuditLogsGrid />
      </Content>
    </>
  );
}
